import { getErrorMessage } from 'application/util/error.util';

import './user-interface.style.sass';
import template from './user-interface.tpl.pug';

class UserInterfaceSettingsController {
    getBalanceWarningThresholdStorageValue() {
        return this.storageService.getUserItem('balance-warning-threshold');
    }

    getBalanceWarningThresholdEnabledStorageValue() {
        return this.storageService.getUserItem('balance-warning-threshold-enabled');
    }

    persistBalanceWarningThresholdSettings() {
        this.storageService.setUserItem('balance-warning-threshold-enabled', !!this.preferences.balanceWarningThresholdEnabled);
        this.storageService.setUserItem('balance-warning-threshold', this.preferences.balanceWarningThreshold);
    }

    broadcastBalanceWarningThresholdUpdated() {
        this.$rootScope.$broadcast('balanceWarningThresholdUpdated', {
            enabled: !!this.preferences.balanceWarningThresholdEnabled,
            threshold: this.preferences.balanceWarningThreshold
        });
    }

    /* @ngInject */
    constructor($rootScope, preferenceService, notificationService, themeService, storageService) {
        this.$rootScope = $rootScope;
        this.preferenceService = preferenceService;
        this.notificationService = notificationService;
        this.themeService = themeService;
        this.storageService = storageService;
    }

    $onInit() {
        this.loading = true;
        this.preferences = {};

        return this.preferenceService.get().then((preferences) => {
            const storedThreshold = this.getBalanceWarningThresholdStorageValue();
            const storedEnabled = this.getBalanceWarningThresholdEnabledStorageValue();
            this.preferences = preferences || {};
            this.preferences.calendarHighlightColor = this.preferences.calendarHighlightColor || 'selected';
            this.preferences.theme = this.preferences.theme || this.themeService.getStoredTheme() || 'system';
            this.preferences.categoryIconStyle = this.preferences.categoryIconStyle || this.storageService.getUserItem('category-icon-style') || 'icons';
            let balanceWarningThreshold = this.preferences.balanceWarningThreshold;

            if (storedThreshold == null) {
                balanceWarningThreshold = this.preferences.balanceWarningThreshold;
            } else {
                balanceWarningThreshold = storedThreshold;
            }

            this.preferences.balanceWarningThreshold = this.normalizeBalanceWarningThreshold(balanceWarningThreshold);

            let balanceWarningThresholdEnabled;

            if (storedEnabled == null) {
                if (this.preferences.balanceWarningThresholdEnabled == null) {
                    balanceWarningThresholdEnabled = this.preferences.balanceWarningThreshold > 0;
                } else {
                    balanceWarningThresholdEnabled = this.preferences.balanceWarningThresholdEnabled === true;
                }
            } else {
                balanceWarningThresholdEnabled = storedEnabled === true || storedEnabled === 'true';
            }

            this.preferences.balanceWarningThresholdEnabled = balanceWarningThresholdEnabled;
        }, (result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to retrieve your user interface settings.`));
        }).finally(() => {
            this.loading = false;
        });
    }

    selectCalendarHighlightColor(value) {
        if (!this.preferences) {
            return;
        }

        this.preferences.calendarHighlightColor = value;
        return this.updatePreferences();
    }

    updatePreferences() {
        return this.preferenceService.save(this.preferences).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to update your user interface settings.`));
        });
    }

    selectTheme(theme) {
        if (!this.preferences) {
            return;
        }

        this.preferences.theme = theme;
        this.themeService.applyTheme(theme);
        return this.updatePreferences();
    }

    selectCategoryIconStyle(style) {
        if (!this.preferences) {
            return;
        }

        this.preferences.categoryIconStyle = style;
        this.storageService.setUserItem('category-icon-style', style);
        this.$rootScope.$broadcast('categoryIconStyleUpdated', style);
        return this.updatePreferences();
    }

    toggleBalanceWarningThreshold(enabled) {
        if (!this.preferences) {
            return;
        }

        this.preferences.balanceWarningThresholdEnabled = !!enabled;

        if (this.preferences.balanceWarningThresholdEnabled && this.preferences.balanceWarningThreshold == null) {
            this.preferences.balanceWarningThreshold = 0;
        }

        this.persistBalanceWarningThresholdSettings();
        this.broadcastBalanceWarningThresholdUpdated();
        return this.updatePreferences();
    }

    updateBalanceWarningThreshold() {
        if (!this.preferences) {
            return;
        }

        this.preferences.balanceWarningThreshold = this.normalizeBalanceWarningThreshold(this.preferences.balanceWarningThreshold);
        this.persistBalanceWarningThresholdSettings();
        this.broadcastBalanceWarningThresholdUpdated();
        return this.updatePreferences();
    }

    normalizeBalanceWarningThreshold(value) {
        if (value === '' || value == null) {
            return null;
        }

        const normalized = Number(value);
        if (!Number.isFinite(normalized)) {
            return null;
        }

        return normalized >= 0
            ? normalized
            : 0;
    }
}

export default {
    selector: 'dbAUserInterfaceSettings',
    template: template(),
    controller: UserInterfaceSettingsController
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/user-interface/user-interface.cmpt.js